/* ============================================
   BS Collection page interactions
   - Filter drawer (mobile)
   - Auto-submit on filter / sort change
   - Quick add to cart
   ============================================ */

(function () {
  'use strict';

  // ---------------------------------------------
  // Filter drawer toggle (mobile)
  // ---------------------------------------------
  document.querySelectorAll('[data-bs-filter-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panelId = btn.getAttribute('aria-controls');
      var panel = document.getElementById(panelId);
      if (!panel) return;
      var isOpen = panel.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.body.classList.toggle('bs-filters-open', isOpen);
    });
  });

  document.querySelectorAll('[data-bs-filter-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = btn.closest('[data-bs-filter-panel]');
      if (!panel) return;
      panel.classList.remove('is-open');
      document.body.classList.remove('bs-filters-open');
      var toggleId = panel.id;
      var toggleBtn = document.querySelector('[aria-controls="' + toggleId + '"]');
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
    });
  });

  // Close drawer on backdrop click (mobile only)
  document.addEventListener('click', function (e) {
    if (!document.body.classList.contains('bs-filters-open')) return;
    if (e.target.closest('[data-bs-filter-panel]')) return;
    if (e.target.closest('[data-bs-filter-toggle]')) return;
    document.querySelectorAll('[data-bs-filter-panel].is-open').forEach(function (panel) {
      panel.classList.remove('is-open');
    });
    document.body.classList.remove('bs-filters-open');
    document.querySelectorAll('[data-bs-filter-toggle]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
  });

  // ---------------------------------------------
  // Auto-submit filter form on change
  // ---------------------------------------------
  document.querySelectorAll('.bs-filters').forEach(function (form) {
    var debounceTimer;

    function applyFilters() {
      var formData = new FormData(form);
      var params = new URLSearchParams();

      formData.forEach(function (value, key) {
        if (value !== '' && value !== null) {
          params.append(key, value);
        }
      });

      // Preserve sort_by from URL if present
      var currentParams = new URLSearchParams(window.location.search);
      var sortBy = currentParams.get('sort_by');
      if (sortBy) params.set('sort_by', sortBy);

      var newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
      window.location.href = newUrl;
    }

    form.addEventListener('change', function (e) {
      if (e.target.type === 'checkbox') {
        applyFilters();
      }
    });

    form.addEventListener('input', function (e) {
      if (e.target.type === 'number') {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(applyFilters, 700);
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      applyFilters();
    });
  });

  // ---------------------------------------------
  // Sort dropdown
  // ---------------------------------------------
  document.querySelectorAll('[data-bs-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', select.value);
      window.location.href = window.location.pathname + '?' + params.toString();
    });
  });

  // ---------------------------------------------
  // Quick add to cart
  // ---------------------------------------------
  document.querySelectorAll('[data-bs-quick-add]').forEach(function (btn) {
    if (btn.tagName !== 'BUTTON') return; // skip <a> fallbacks
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      var originalContent = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '<span>Toevoegen...</span>';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg><span>Toegevoegd</span>';
          // Trigger cart update events that themes may listen for
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          window.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(function () {
            btn.innerHTML = originalContent;
            btn.disabled = false;
          }, 1800);
        })
        .catch(function () {
          btn.innerHTML = '<span>Probeer opnieuw</span>';
          setTimeout(function () {
            btn.innerHTML = originalContent;
            btn.disabled = false;
          }, 1800);
        });
    });
  });
})();
